import { AppKey } from "shared-ts-app-info";

export const resolveKey = (
  name: string,
  app: AppKey | null | undefined,
  user: string | null | undefined
): string => {
  return app != null
    ? user != null
      ? `${app}:${user}:${name}`
      : `${app}::${name}`
    : `::${name}`;
};
